const postPlacesStr = {
  toastr: 'Lugar agregado',
  toastr1: 'fue agregado con éxito',
  toastrError: 'Lugar ya registrado',
  toastrError1: 'Ingrese otro nombre'
};

export default postPlacesStr;
